var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"my-button",class:{
    'my-button--teal': _vm.type === 'teal',
    'my-button--fill-blue': _vm.type === 'fill-blue',
    'my-button--fill-red': _vm.type === 'fill-red',
    'my-button--outline-red': _vm.type === 'outline-red',
    'my-button--fill-yellow': _vm.type === 'fill-yellow',
    'my-button--block': _vm.block !== false
  },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }